module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIGITAL_CAMOUFLAGE_DESERT.70a5febe.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIGITAL_CAMOUFLAGE_DESERT.png
// module id = 1274
// module chunks = 16